export const LANDING_PAGE = {
  home: '/landing',
  five: '/landing/obrigado-5off',
  ten: '/landing/obrigado-10off',
  registration: '/landing/registro',
};
